import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const BoldText = ({ children }: Props) => (
  <span className="font-semibold text-black">{children}</span>
);

export const DangerText = ({ children }: Props) => (
  <span className="font-semibold text-red-700 underline">{children}</span>
);

export const InfoText = ({ children }: Props) => (
  <span className="font-semibold text-blue-700 underline">{children}</span>
);

export const ClauseText = ({ children }: Props) => (
  <span className="font-semibold text-black">{children}</span>
);
